import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { UploadDTO } from '@api/upload/dto/UploadDTO';
import { isInspector } from '@utils/UserRoleSelector';
import UploadStatus, { StatusName } from '@constants/uploadStatus';
import usePostUploadStatus from '@api/upload/hooks/usePostUploadStatus';
import useGetUser from '@api/user/hooks/useGetUser';
import RejectionModal from '../RejectionReason/RejectionModal';

type Props = {
  uploadDTO: UploadDTO;
  triggerTableRefresh: (uploadsTableRefresh: boolean) => void;
};

function AcceptAndRejectOption({ uploadDTO, triggerTableRefresh }: Props) {
  const { t } = useTranslation();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);
  const uploadStatus = UploadStatus[uploadDTO.status as StatusName];
  const changeFileSetStatus = usePostUploadStatus(triggerTableRefresh);
  const { data: user } = useGetUser();

  const canRender =
    UploadStatus.WAITING_FOR_ACCEPTANCE === uploadStatus ||
    UploadStatus.IN_PROGRESS === uploadStatus;

  if (!user || !canRender || !isInspector(user)) {
    return null;
  }

  return (
    <>
      {!uploadDTO.hasRejectedReport && (
        <Button
          content={t('upload.accept')}
          icon="save"
          labelPosition="left"
          positive
          onClick={() => {
            setIsSubmitDisabled(true);
            changeFileSetStatus({
              id: uploadDTO.id,
              status: UploadStatus.ACCEPTED_AND_DISTRIBUTED,
              reason: '',
            });
          }}
          disabled={isSubmitDisabled}
        />
      )}
      <RejectionModal
        buttonTitle={t('upload.reject.all')}
        rejectFileSet={reason => {
          changeFileSetStatus({ id: uploadDTO.id, status: UploadStatus.REFUSED, reason });
        }}
      />
    </>
  );
}

export default AcceptAndRejectOption;
